module.exports = __webpack_public_path__ + "static/media/BONDLY-BNB.8d60e218.svg";